import React, { CSSProperties } from 'react';

interface Props {
  partial?: boolean;
  fontsize?: string;
  text?: string;
}

const overlay: CSSProperties = {
  background: '#ffffff',
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  zIndex: 1,
};

export default function Loader(props: Props) {
  const { partial, text, fontsize } = props;

  return (
    <>
      {!partial ? (
        <>
          <span style={overlay} data-testid="spinner" />
          <span style={{
            zIndex: 10000,
            position: 'absolute',
            textAlign: 'center',
            left: '50%',
            width: 52,
            height: 52,
            marginLeft: -26,
            top: '50%',
            marginTop: -26,
          }}
          >
            { text }
            <i
              aria-label="spinner"
              className="spinner-component fa fa-spinner fa-pulse fa-3x fa-fw"
              style={{ fontSize: fontsize || '40px', opacity: 0.7 }}
            />
          </span>
        </>
      ) : (
        <i
          aria-label="spinner"
          className="spinner-component fa fa-spinner fa-pulse fa-3x fa-fw"
          style={{ fontSize: fontsize || '40px', opacity: 0.7 }}
        />
      )}
    </>
  );
}
